import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const DocumentationTree = () => {
  const location = useLocation();
  const [expandedNodes, setExpandedNodes] = useState({
    'api-basics': true,
    'authentication': false,
    'endpoints': false,
    'best-practices': false
  });

  const documentationStructure = [
    {
      id: 'api-basics',
      label: 'API Basics',
      icon: 'BookOpen',
      children: [
        { id: 'introduction', label: 'Introduction', anchor: '#introduction' },
        { id: 'getting-started', label: 'Getting Started', anchor: '#getting-started' },
        { id: 'base-url', label: 'Base URL & Endpoints', anchor: '#base-url' },
        { id: 'http-methods', label: 'HTTP Methods', anchor: '#http-methods' },
        { id: 'response-format', label: 'Response Format', anchor: '#response-format' },
        // { id: 'rate-limiting', label: 'Rate Limiting', anchor: '#rate-limiting' },
        { id: 'status-codes', label: 'HTTP Status Codes', anchor: '#status-codes' }
      ]
    },
    {
      id: 'authentication',
      label: 'Authentication',
      icon: 'Shield',
      children: [
        { id: 'auth-overview', label: 'Authentication Overview', anchor: '#auth-overview' },
        { id: 'api-auth', label: 'API Key Authentication', anchor: '#api-auth' },
        { id: 'api-keys', label: 'Generate API Keys', anchor: '#api-keys' },
        // { id: 'oauth', label: 'Roll API Keys', anchor: '#oauth' },
        { id: 'roll-api-keys', label: 'Roll API Keys', anchor: '#roll-api-keys' },
        { id: 'get-token', label: 'Get Token', anchor: '#get-token' }
        // { id: 'security-practices', label: 'Security Best Practices', anchor: '#security-practices' }
      ]
    },
    {
      id: 'best-practices',
      label: 'Best Practices',
      icon: 'CheckCircle',
      children: [
        { id: 'best-practices', label: 'Error Handling', anchor: '#best-practices' }
        // { id: 'pagination', label: 'Pagination Guidelines', anchor: '#pagination' },
        // { id: 'filtering-sorting', label: 'Filtering & Sorting', anchor: '#filtering-sorting' },
        // { id: 'versioning', label: 'API Versioning', anchor: '#versioning' },
        // { id: 'testing', label: 'Testing Your Integration', anchor: '#testing' }
      ]
    },
    {
      id: 'glossary',
      label: 'Glossary',
      icon: 'BookText',
      children: [
        { id: 'terms-definitions', label: 'Terms & Definitions', anchor: '#terms-definitions' }
        // { id: 'common-errors', label: 'Common Error Codes', anchor: '#common-errors' },
        // { id: 'troubleshooting', label: 'Troubleshooting Guide', anchor: '#troubleshooting' }
      ]
    },
    {
      id: 'endpoints',
      label: 'API Endpoints',
      icon: 'Globe',
      children: [
        { id: 'products-api', label: 'Products API', anchor: '#products-api' },
        { id: 'brands-api', label: 'Brands API', anchor: '#brands-api' },
        { id: 'categories-api', label: 'Categories API', anchor: '#categories-api' },
        { id: 'pincode-api', label: 'Pincode Serviceable API', anchor: '#pincode-api' },
        { id: 'stock-api', label: 'Stock Availability API', anchor: '#stock-api' },
        { id: 'orders-api', label: 'Orders API', anchor: '#orders-api' },
        { id: 'invoice-api', label: 'Invoice API', anchor: '#invoice-api' },
        { id: 'webhooks-api', label: 'Webhooks API', anchor: '#webhooks-api' }
      ]
    }
  ];

  const toggleNode = (nodeId) => {
    setExpandedNodes(prev => ({
      ...prev,
      [nodeId]: !prev?.[nodeId]
    }));
  };

  const isActiveLink = (path) => {
    return location.pathname + location.hash === path;
  };

  return (
    <div className="space-y-1">
      {documentationStructure?.map((node) => (
        <div key={node?.id} className="space-y-1">
          <button
            onClick={() => toggleNode(node?.id)}
            className="flex items-center justify-between w-full px-2 py-1.5 text-xs font-medium text-muted-foreground hover:text-foreground transition-smooth rounded-md hover:bg-muted/50"
          >
            <div className="flex items-center space-x-2">
              <Icon name={node?.icon} size={14} />
              <span>{node?.label}</span>
            </div>
            <Icon 
              name={expandedNodes?.[node?.id] ? "ChevronDown" : "ChevronRight"} 
              size={12} 
            />
          </button>
          {expandedNodes?.[node?.id] && (
            <div className="ml-4 space-y-0.5">
              {node?.children?.map((child) => {
                const href = child?.anchor || child?.path; // Prefer anchor if available
                return child?.anchor ? (
                  <a
                    key={child?.id}
                    href={child?.anchor}
                    className={`
                      block px-2 py-1 text-xs rounded-md transition-smooth
                      ${location.hash === child?.anchor
                        ? 'bg-accent/10 text-accent font-medium'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted/30'
                      }
                    `}
                  >
                    {child?.label}
                  </a>
                ) : (
                  <Link
                    key={child?.id}
                    to={child?.path}
                    className={`
                      block px-2 py-1 text-xs rounded-md transition-smooth
                      ${isActiveLink(child?.path)
                        ? 'bg-accent/10 text-accent font-medium'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted/30'
                      }
                    `}
                  >
                    {child?.label}
                  </Link>
                );
              })}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default DocumentationTree;